// extracted by mini-css-extract-plugin
export default {"section-separator":"section-separator_section-separator__A42Ip"};